<template>
  <div class="upcoming-event-report-container">
    <div class="row">
    <div v-for="item in reports" class="col-md-6 col-lg-4">
      <EventChart :eventItem="item" :key="item.id"></EventChart>
    </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import EventChart from './EventChart';
  import _ from 'lodash';
  export default {
    name: 'c-upcoming-report',
    components: {
      EventChart
    },
    data () {
      return {
        reports: [],
        pagingObj: {
          currentPage: 0,
          itemsPerPage: 50
        }
      }
    },
    props: {
      reportType: {
        type: String,
        required: true
      },
      textSearch: {
        type: String,
        required: false
      },
      dateOut: {
        type: Array,
        default: () => ['0', '60+']
      },
      filterBy: {
        type: Array,
        default: () => ['dateTime']
      }
    },
    computed: {
      ...mapGetters({
        getEventListReports: 'GETTER_GET_EVENT_LIST_REPORTS'
      })
    },
    methods: {
      getDataReport (params) {
        let body = {
          noBeginDates: this.dateOut[0],
          noEndDates: this.dateOut[1],
          selectedDate: null,
          clientId: this.$route.params.clientId,
          keyword: this.textSearch,
          currentPage: this.pagingObj.currentPage || 1,
          itemsPerPage: this.pagingObj.itemsPerPage || 25,
          sortType: this.filterBy[0],
          eventStatus: 'upcoming',
          requireReport: true,
          ...params
        };
        this.getEventsByDate(body).then((response) => {
          if (response.message === null) {
            this.reports = response.approvedEvents[0].events;
          } else {
            this.reports = [];
          }
        });
      },
      getEvents () {
      },
      ...mapActions({
        getEventsByDate: 'ACTION_GET_EVENTS_BY_DATES',
        actionGetEventReportChart: 'ACTION_GET_EVENT_REPORT_CHART'
      })
    },
    created () {
      let params = {
        noBeginDates: '0',
        noEndDates: '60+'
      };
      this.getDataReport(params);
    },
    watch: {
      dateOut: {
        handler: function (val, oldVal) {
          if (val[0] === oldVal[0] && val[1] === oldVal[1]) {
            return;
          }
          let params = {
            noBeginDates: val[0],
            noEndDates: val[1]
          };
          this.getDataReport(params);
        },
        deep: true
      },
      filterBy: {
        handler: function (val, oldVal) {
          if (val[0] === oldVal[0]) {
            return;
          }
          let params = {
            sortType: val[0]
          };
          this.getDataReport(params);
        },
        deep: true
      },
      textSearch: _.debounce(function () {
        let keyword = this.textSearch.trim().toLowerCase();
        if (keyword.length >= 2 || keyword.length === 0) {
          this.getDataReport({ keyword: keyword });
        }
      }, 700)
    }
  };
</script>



// WEBPACK FOOTER //
// UpcommingReport.vue?e9273b70